import { ConfirmDialog } from '~/components/ConfirmDialog/ConfirmDialog';
import { toText } from '~/pages/referee/hooks/useRefereeEligibilities';
import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { useDeleteRefereeLicenseMutation } from '../../mutations';
import { useAuthentication } from '~/hooks/useAuthentication';
import { insertOnCondition } from '~/utils/array';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { useDialog } from '~/hooks/useDialog';
import { Fragment } from 'react/jsx-runtime';
import { JudgeLicense } from '~/apis/ssf';
import { toast } from 'react-toastify';

interface Props {
  isLoading: boolean;
  licenses: JudgeLicense[];
}

function Row({ license }: { license: JudgeLicense }) {
  const { can } = useAuthentication();

  const mutation = useDeleteRefereeLicenseMutation();
  const dialog = useDialog();

  async function handleDelete() {
    await toast.promise(mutation.mutateAsync(license.id), {
      success: 'Licensen har tagits bort',
      pending: 'Tar bort licens...',
    });
  }

  return (
    <Fragment>
      <Table.Row>
        <Table.Col>
          <Link to={`${license.id}`}>{license.club?.name}</Link>
        </Table.Col>
        <Table.Col>
          {toText(license.level)}
        </Table.Col>
        <Table.Col>{license.start_date}</Table.Col>
        <Table.Col>{license.end_date}</Table.Col>
        <Table.Col align="right">
          <Table.Context
            items={[
              ...insertOnCondition(
                <ContextMenu.Item label="Redigera" key="edit" to={`${license.id}/edit`} />,
                can('edit-referee-license')
              ),
              ...insertOnCondition(
                <ContextMenu.Item label="Ta bort" key="delete" onClick={dialog.open} danger />,
                can('delete-referee-license')
              ),
            ]}
          />
        </Table.Col>
      </Table.Row>

      <ConfirmDialog {...dialog} isLoading={mutation.isPending} onConfirm={handleDelete} />
    </Fragment>
  );
}

export function RefereeLicensesListTable({ licenses, isLoading }: Props) {
  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col as="th">Förening</Table.Col>
          <Table.Col as="th">Nivå</Table.Col>
          <Table.Col as="th">Start</Table.Col>
          <Table.Col as="th">Slut</Table.Col>
          <Table.Col as="th" />
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {isLoading ? <Table.Loading cols={3} /> : licenses.map(license => <Row license={license} key={license.id} />)}
      </Table.Body>
    </Table>
  );
}
